const header = document.querySelector('.header');

const handleHeader = () => {
    const distanceScrolled = window.pageYOffset;

    if (distanceScrolled > 20) {
        if (! header.classList.contains('compact')) {
            header.classList.add('compact');
        }
    } else {
        if (header.classList.contains('compact')) {
            header.classList.remove('compact');
        }
    }
};

window.addEventListener('load', () => {
    handleHeader();
});

window.addEventListener('scroll', handleHeader);
